var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartly({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 22,
    viewBox: "0 0 137 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.752V10.9856H12.7803V0.9375L38.4222 6.27072V10.9856H26.0389V21.0595L0.5 15.752Z",
    fill: "#161B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1652 9.0063H55.4852C55.0911 6.24872 52.3417 6.83456 51.5703 7.12372C51.0552 7.31678 50.5147 8.12013 50.8346 8.79418C51.124 9.40403 51.805 9.75299 53.9087 9.8813C57.7343 10.1146 58.6207 12.1351 58.5856 13.1162C58.5856 14.548 58.2966 17.0847 53.3044 17.3321C48.596 17.5654 47.6466 14.495 47.7605 12.9306H50.4668C50.4457 14.8821 52.017 15.1313 53.0942 15.1313C54.3029 15.1313 55.4852 14.8662 55.4852 13.6199C55.4852 12.623 54.8021 12.1616 53.9087 12.1086C51.8944 12.1439 47.8446 11.573 47.7605 9.0063C47.6554 5.79796 50.0726 4.41917 54.3029 4.68432C57.687 4.89644 58.2879 7.65403 58.1652 9.0063Z",
    fill: "#161B20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.051 17.3447H131.993V12.3829L136.598 4.65234H133.272L130.765 9.61413L129.051 6.29714C128.846 5.74887 128.125 4.65234 126.877 4.65234H124.37L129.051 12.3829V17.3447Z",
    fill: "#161B20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.785 17.3447V4.65234H118.402C119.525 4.65234 119.806 5.61886 119.806 6.10211V14.7734C120.478 14.7643 122.192 14.7515 123.676 14.7734C125.16 14.7953 125.478 15.4025 125.451 15.7034V17.3447H116.785Z",
    fill: "#161B20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.185 17.3447H111.12V7.08747H114.464V5.74719C114.464 5.09046 114.004 4.63121 112.371 4.65309C110.737 4.67498 106.688 4.66221 104.867 4.65309V7.08747H108.185V17.3447Z",
    fill: "#161B20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4841 17.3447H95.3958V12.6227H98.3834C98.8307 12.5495 99.7253 12.738 99.7253 14.0777V17.3447H102.536V13.5836C102.536 12.9613 102.232 11.6673 101.017 11.4697C101.574 11.2134 102.657 10.2507 102.536 8.44981C102.384 6.19865 100.611 4.77108 98.1049 4.68872C96.0997 4.62284 93.5222 4.66127 92.4841 4.68872V17.3447ZM95.4211 10.7284V7.15951H98.2568C98.8138 7.18696 99.9279 7.57131 99.9279 8.88906C99.9279 10.2068 98.8138 10.6644 98.2568 10.7284H95.4211Z",
    fill: "#161B20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2153 17.3447H77.1606L81.834 4.67678C82.0342 4.65834 82.7635 4.63252 84.0793 4.67678C85.3952 4.72103 86.0026 5.70939 86.1419 6.19803L90.1625 17.3447H86.7685C86.5596 15.1983 85.5327 14.717 85.0453 14.7447H81.0769L80.2153 17.3447ZM85.2542 12.6703H81.7818L83.4527 7.27675L85.2542 12.6703Z",
    fill: "#161B20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3728 4.65234V17.3447H64.047V7.57294L67.1366 17.3447H69.7069L72.7705 7.76401V17.3447H75.7563C75.7649 14.0692 75.777 7.2454 75.7563 6.15359C75.7355 5.06177 74.9687 4.69784 74.5879 4.65234H71.1608L68.5905 13.0593C68.0799 11.5308 66.9704 8.09155 66.6173 6.56302C66.2642 5.03448 65.3971 4.65234 65.0076 4.65234H61.3728Z",
    fill: "#161B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartly);
export default __webpack_public_path__ + "static/media/smartly.066143fc262f7b2a2987aaaee7aea5b9.svg";
export { ForwardRef as ReactComponent };